export default "__VITE_ASSET__37eaca1b__"